import {createSelector} from 'reselect';
import getAllPaymentOptionAttributes from '../../../sections/PaymentOptionsSection/PaymentOptions/getPaymentOptionAttributes';
import {getPaymentOptions} from './PaymentOptionSelectors';

export const getPaymentOptionAttributes = createSelector(
  [getPaymentOptions],
  paymentOptions => paymentOptions.map(paymentOption => getAllPaymentOptionAttributes(paymentOption)),
);

const getArrayOfDisabledFuncs = createSelector(
  [getPaymentOptionAttributes],
  paymentOptionAttributes => paymentOptionAttributes.map(attrs => attrs.getIsDisabled),
);

const getArrayOfMessageFuncs = createSelector(
  [getPaymentOptionAttributes],
  paymentOptionAttributes => paymentOptionAttributes.map(attrs => attrs.getMessage),
);

export const getPaymentOptionDisabledStatuses = state => getArrayOfDisabledFuncs(state)
  .map(disabledFunc => disabledFunc(state));

export const getPaymentOptionMessages = state => getArrayOfMessageFuncs(state)
  .map(messageFunc => messageFunc(state));

export function getPaymentOptionHiddenStatusesFromPaymentAttributes(state) {
  const arrayOfHiddenFuncs = getPaymentOptionAttributes(state).map(attrs => attrs.getShouldHide);
  return arrayOfHiddenFuncs
    .map(getShouldHide => getShouldHide(state));
}

export function getPaymentOptionHiddenStatusesIfGiftcardApplied(state) {
  const arrayOfHiddenFuncs = getPaymentOptionAttributes(state).map(attrs => attrs.getShouldHideIfGiftcardApplied);
  return arrayOfHiddenFuncs
    .map(getShouldHideIfGiftcardApplied => getShouldHideIfGiftcardApplied()(state));
}

export function getPaymentOptionHiddenStatuses(state) {
  const hiddenStatusesIfGiftcardApplied = getPaymentOptionHiddenStatusesIfGiftcardApplied(state);
  const hiddenStatusesFromPaymentAttributes = getPaymentOptionHiddenStatusesFromPaymentAttributes(state);
  return hiddenStatusesFromPaymentAttributes.map((hiddenFromAttribute, index) => hiddenFromAttribute || hiddenStatusesIfGiftcardApplied[index]);
}
